export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function formatINR(n?: number | string | null): string {
  const num = Number(n);
  const safeNum = Number.isFinite(num) ? num : 0;
  return `\u20B9${safeNum.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatDate(iso?: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "Asia/Kolkata",
  });
}

export function formatTime(iso?: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleTimeString("en-IN", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  });
}

export function formatDateTime(iso?: string | null): string {
  if (!iso) return "—";
  return `${formatDate(iso)}, ${formatTime(iso)}`;
}

export const RANGES = [
  "Today",
  "Last 7 Days",
  "Last 30 Days",
  "This Month",
  "Last 3 Months",
  "Custom Range",
];

export const CANCEL_REASONS = [
  "Customer Request",
  "Loan Closed",
  "Incorrect Details",
  "Duplicate Mandate",
  "Other",
].map((r) => ({ value: r, label: r }));